(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

// Enhance only this section's rendered cards; search and purchase behavior remain native.
if (!customElements.get('five-shop-tools')) {
  customElements.define('five-shop-tools', class FiveShopTools extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'five-alone-collection-photo-view';
      this.view = 'artwork';
      this.hiddenStates = new Map();
      this.frame = 0;
      this.detailsFrame = 0;
      this.quickAddHandle = null;
      this.onQuickAddClick = (event) => {
        const button = event.target.closest?.('.quick-add__button--choose');
        if (!button || button.disabled || !this.scope?.contains(button)) return;
        const card = button.closest('product-card');
        const nativeLink = card?.querySelector('.product-card__link[href], .card-gallery a.contents[href]');
        this.quickAddHandle = this.productHandle(nativeLink?.getAttribute('href'));
        this.connectDetailsObserver();
        this.scheduleDetails();
      };
      this.onQuickAddClose = () => {
        this.quickAddHandle = null;
        this.removeDetailsLink();
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-five-photo-view]');
        if (!button || !this.contains(button)) return;
        this.setView(button.dataset.fivePhotoView, true);
      };
    }

    connectedCallback() {
      this.scope = this.closest('results-list');
      if (!this.scope) return;
      try {
        this.view = sessionStorage.getItem(this.storageKey) === 'worn' ? 'worn' : 'artwork';
      } catch (_) { this.view = 'artwork'; }
      this.addEventListener('click', this.onClick);
      this.scope.addEventListener('click', this.onQuickAddClick, true);
      this.connectDetailsObserver();
      this.observer = new MutationObserver((records) => {
        const relevant = records.some((record) => this.collectionMutationNeedsRefresh(record));
        if (relevant) this.schedule();
      });
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'sizes', 'alt', 'disabled', 'aria-pressed', 'hidden', 'class', 'aria-hidden', 'inert']
      });
      this.setView(this.view, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.scope?.removeEventListener('click', this.onQuickAddClick, true);
      this.detailsObserver?.disconnect();
      this.detailsDialog?.removeEventListener('close', this.onQuickAddClose);
      this.detailsObserver = null;
      this.detailsModal = null;
      this.detailsDialog = null;
      cancelAnimationFrame(this.detailsFrame);
      this.detailsFrame = 0;
      this.quickAddHandle = null;
      this.removeDetailsLink();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.hiddenStates.forEach((state, element) => this.restoreVisibility(element));
      this.hiddenStates.clear();
      this.scope?.querySelectorAll('.five-worn-active').forEach((gallery) => gallery.classList.remove('five-worn-active'));
      this.scope?.querySelectorAll('.five-worn-preview').forEach((preview) => { preview.hidden = true; });
    }

    collectionMutationNeedsRefresh(record) {
      const target = record.target;
      if (record.type === 'attributes') {
        if (target.classList.contains('five-worn-preview')) return false;
        if (target.matches('[data-five-photo-view]') && this.contains(target)) {
          return target.disabled || target.getAttribute('aria-pressed') !== String(target.dataset.fivePhotoView === this.view);
        }
        if (target.matches('[data-five-worn-note]') && this.contains(target)) {
          return target.hidden !== (this.view !== 'worn');
        }
        if (record.attributeName === 'class' && target.matches('.card-gallery')) {
          const preview = target.querySelector('a.contents > .five-worn-preview');
          const shouldBeActive = this.view === 'worn' && !!preview && !preview.hidden && preview.complete && preview.naturalWidth > 0;
          return target.classList.contains('five-worn-active') !== shouldBeActive;
        }
        if (['aria-hidden', 'inert'].includes(record.attributeName) && this.hiddenStates.has(target) && target.closest('.five-worn-active')) {
          return target.getAttribute('aria-hidden') !== 'true' || !target.hasAttribute('inert');
        }
        return ['src', 'srcset', 'sizes', 'alt'].includes(record.attributeName) && target.matches('img');
      }
      if (record.type === 'characterData') {
        return !!target.parentElement?.closest('.quick-add__button--choose') && target.textContent.trim() === 'Choose';
      }
      // Native morph may keep all product nodes but remove only our client-added images.
      // Their removal must repair Worn; our own insertion must not schedule itself.
      if (this.view === 'worn' && this.scope?.contains(target) && [...record.removedNodes].some((node) =>
        node.nodeType === 1 && node.classList.contains('five-worn-preview')
      )) return true;
      return [...record.addedNodes, ...record.removedNodes].some((node) => {
        if (node.nodeType !== 1 || node.classList.contains('five-worn-preview')) return false;
        return node.matches('product-card, .card-gallery, slideshow-component, slideshow-slide, img, quick-add-component, [data-five-photo-view], [data-five-worn-note]')
          || !!node.querySelector('product-card, .card-gallery, slideshow-slide img, quick-add-component, [data-five-photo-view], [data-five-worn-note]');
      });
    }

    productHandle(href) {
      if (!href) return null;
      try {
        const url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return null;
        return url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || null;
      } catch (_) { return null; }
    }

    connectDetailsObserver() {
      const modal = document.getElementById('quick-add-modal-content');
      if (!modal || (this.detailsModal === modal && this.detailsObserver)) return;
      this.detailsObserver?.disconnect();
      this.detailsDialog?.removeEventListener('close', this.onQuickAddClose);
      this.detailsModal = modal;
      this.detailsDialog = modal.closest('dialog');
      this.detailsDialog?.addEventListener('close', this.onQuickAddClose);
      this.detailsObserver = new MutationObserver((records) => {
        const relevant = records.some((record) => {
          if (record.type === 'attributes') {
            return record.target.matches('.product-header a, .view-product-title a');
          }
          return [...record.addedNodes, ...record.removedNodes].some((node) =>
            node.nodeType === 1 && !node.classList.contains('five-quick-add-details')
          );
        });
        if (relevant) this.scheduleDetails();
      });
      this.detailsObserver.observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }

    scheduleDetails() {
      if (this.detailsFrame) return;
      this.detailsFrame = requestAnimationFrame(() => {
        this.detailsFrame = 0;
        if (this.isConnected) this.syncDetailsLink();
      });
    }

    removeDetailsLink() {
      this.detailsLink?.remove();
      this.detailsLink = null;
    }

    syncDetailsLink() {
      const modal = this.detailsModal;
      if (!this.quickAddHandle || !modal?.isConnected) return;
      const nativeLink = [...modal.querySelectorAll('.product-header a[href], .view-product-title a[href]')]
        .find((link) => this.productHandle(link.getAttribute('href')) === this.quickAddHandle);
      const purchaseControls = modal.querySelector('product-form-component');
      if (!nativeLink || !purchaseControls) {
        this.removeDetailsLink();
        return;
      }

      let link = this.detailsLink;
      if (!link || !modal.contains(link)) {
        // Only the explicit collection-originated opener owns this one supplementary link.
        modal.querySelectorAll('.five-quick-add-details').forEach((oldLink) => oldLink.remove());
        link = document.createElement('a');
        link.className = 'five-quick-add-details';
        link.textContent = 'Size guide & full details';
        this.detailsLink = link;
      }
      const href = nativeLink.getAttribute('href');
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      // Stay outside the native form, immediately after its component. Do not clone or replace controls.
      if (purchaseControls.nextElementSibling !== link) purchaseControls.insertAdjacentElement('afterend', link);
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) {
          this.syncViewControls();
          this.syncCards();
        }
      });
    }

    syncViewControls() {
      // Native sorting can morph server-default controls into this retained custom element.
      this.querySelectorAll('[data-five-photo-view]').forEach((button) => {
        if (button.disabled) button.disabled = false;
        const pressed = String(button.dataset.fivePhotoView === this.view);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
      const note = this.querySelector('[data-five-worn-note]');
      if (note && note.hidden !== (this.view !== 'worn')) note.hidden = this.view !== 'worn';
    }

    setView(view, announce) {
      this.view = view === 'worn' ? 'worn' : 'artwork';
      try { sessionStorage.setItem(this.storageKey, this.view); } catch (_) { /* Browsing still works without storage. */ }
      this.syncViewControls();
      if (announce) {
        const status = this.querySelector('[data-five-view-status]');
        if (status) status.textContent = this.view === 'worn'
          ? 'Worn previews selected. Artwork is shown where a preview is unavailable.'
          : 'Artwork photos selected.';
      }
      this.syncCards();
    }

    hideFromAssistiveTechnology(element) {
      if (!this.hiddenStates.has(element)) {
        this.hiddenStates.set(element, { ariaHidden: element.getAttribute('aria-hidden'), inert: element.hasAttribute('inert') });
      }
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('inert', '');
    }

    restoreVisibility(element) {
      const previous = this.hiddenStates.get(element);
      if (!previous) return;
      if (previous.ariaHidden === null) element.removeAttribute('aria-hidden');
      else element.setAttribute('aria-hidden', previous.ariaHidden);
      if (!previous.inert) element.removeAttribute('inert');
      this.hiddenStates.delete(element);
    }

    showPreview(gallery, active) {
      gallery.classList.toggle('five-worn-active', active);
      gallery.querySelectorAll('slideshow-slides, slideshow-arrows, slideshow-controls').forEach((element) => {
        if (active) this.hideFromAssistiveTechnology(element);
        else this.restoreVisibility(element);
      });
    }

    syncCards() {
      if (!this.scope) return;
      this.hiddenStates.forEach((state, element) => {
        if (!element.isConnected) this.restoreVisibility(element);
      });
      this.scope.querySelectorAll('product-card').forEach((card) => {
        // Retain the actual button, its delegated handler, attributes, disabled state and any spinner.
        card.querySelectorAll('.quick-add__button--choose').forEach((button) => {
          const text = [...button.childNodes].find((node) => node.nodeType === 3 && node.textContent.trim() === 'Choose');
          const productTitle = button.closest('quick-add-component')?.dataset.productTitle || '';
          const shopLabel = /hoodie\s*$/i.test(productTitle) ? 'Shop Hoodie' : /(?:cap|hat)\s*$/i.test(productTitle) ? 'Shop Hat' : 'Shop Shirt';
          if (text) text.textContent = shopLabel;
        });

        const gallery = card.querySelector('.card-gallery');
        const link = gallery?.querySelector('a.contents');
        if (!gallery || !link) return;
        let preview = link.querySelector(':scope > .five-worn-preview');
        const source = [...link.querySelectorAll('slideshow-slide img')].find((image) =>
          (image.getAttribute('src') || '').includes('-lifestyle-')
        );

        if (this.view !== 'worn' || !source) {
          this.showPreview(gallery, false);
          if (preview) preview.hidden = true;
          return;
        }

        if (!preview) {
          preview = document.createElement('img');
          preview.className = 'five-worn-preview';
          preview.loading = 'lazy';
          preview.decoding = 'async';
          preview.setAttribute('fetchpriority', 'low');
          link.append(preview);
        }

        // A toolbar can be replaced while its cards remain. Refresh ownership of pending image events.
        preview.onload = () => {
          if (this.isConnected && link.contains(preview)) {
            this.showPreview(gallery, this.view === 'worn' && !preview.hidden && preview.naturalWidth > 0);
          }
        };
        preview.onerror = () => this.showPreview(gallery, false);

        const attributes = ['srcset', 'sizes', 'alt', 'width', 'height', 'src'];
        const changed = attributes.some((name) => preview.getAttribute(name) !== source.getAttribute(name));
        if (changed) this.showPreview(gallery, false);
        attributes.forEach((name) => {
          const value = source.getAttribute(name);
          if (preview.getAttribute(name) === value) return;
          if (value === null) preview.removeAttribute(name);
          else preview.setAttribute(name, value);
        });
        preview.hidden = false;
        this.showPreview(gallery, preview.complete && preview.naturalWidth > 0);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
